<script>
    import { fly } from "svelte/transition";
    import { Switch } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Switch />
    </div>
    <h4 class="example-title">文字</h4>
    <div class="example-body">
        <Switch checkedText="开" uncheckedText="关" />
    </div>
    <div class="example-body">
        <Switch checkedText="1" uncheckedText="0" />
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
